module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746a_logo_200x200.c4f2144e.png";